// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___oDSER","root__wrapper":"style-module__root__wrapper___BigJI","root__img":"style-module__root__img___Bnq2w","root__type":"style-module__root__type___nQwMZ","root__feature":"style-module__root__feature___hm5ka"};
    if(module.hot) {
      // 1697460476391
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  